<template>
  <v-container fluid style="padding: 20px">
    <v-checkbox
      v-model="selected"
      v-for="(item, key, index) in checkListItems"
      :key="index"
      :label="$t(item)"
      :value="item"
    ></v-checkbox>
  </v-container>
</template>

<script>
export default {
  name: "check-list",
  data() {
    return {};
  },
  props: {
    checkListItems: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.$store.commit("SET_SELECTED", []);
  },

  watch: {
    selected: function() {
      console.log(this.selected);
      this.$store.commit("SET_SELECTED", this.selected);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CheckList.vue